// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    // Start Boost 195481
    InstantSearchResultItemProduct.prototype.setData = function (data) {
		if (data) {
            var newImageUrl = data.images_info.length > 0 ? Utils.optimizeImage(data.images_info[0].src, '200x') : boostPFSConfig.general.no_image_url;
            var availableVariantsWithImages = data.variants.filter(function(variant){
              return variant.available && variant.image;
            })
            if(availableVariantsWithImages.length > 0){
              newImageUrl =  Utils.optimizeImage(availableVariantsWithImages[0].image, '200x');
            }  
			this.data = data;
			this.id = data.id;
			this.title = Utils.stripHtml(data.title);
			this.imageUrl = newImageUrl;
			this.url = Utils.buildProductItemUrlWithVariant(data);
			this.sku = Utils.stripHtml(data.skus && data.skus.length > 0 ? data.skus[0] : '');
			this.label = Utils.stripHtml(data.label);
			this.vendor = Utils.stripHtml(data.vendor);
			this.isShow = true;
		} else {
			this.data = null;
			this.id = '';
			this.title = '';
			this.imageUrl = '';
			this.url = '';
			this.sku = '';
			this.label = '';
			this.vendor = '';
			
			this.isShow = false;
		}
	}
    // End Boost 195481
    var productData = InstantSearchResultItemProduct.prototype.setData;
    InstantSearchResultItemProduct.prototype.setData = function(data) {
      productData.call(this, data);

      if (this.data) {
        var searchTerm = this.parent.parent.searchQuery;

        this.data.skuVariant = this.data.variants.find(v => v.sku.toLowerCase() === (searchTerm || '').trim().toLowerCase());
        
        if (this.data.skuVariant) {
          if (this.data.skuVariant.image) {
            this.imageUrl = Utils.optimizeImage(this.data.skuVariant.image, '200x')
          }

          this.data.price_min = parseFloat(this.data.skuVariant.price);
          this.data.compare_at_price_min = parseFloat(this.data.skuVariant.compare_at_price);
          this.url += '?variant=' + this.data.skuVariant.id;
        } 
      }
    }

    // Start Boost 175845
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
      		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
        var priceMin = this.data.price_min;
        var compareAtPriceMin = this.data.compare_at_price_min;
        var fromText = '';
      
          var sortedVariants = this.data.variants.filter(variant => parseFloat(variant.price) !== 0 && variant.available);
          sortedVariants.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
          if (sortedVariants.length > 0) {
              if (typeof sortedVariants[0].price == "number") {
                priceMin = parseFloat(sortedVariants[0].price / 100);
                compareAtPriceMin = parseFloat(sortedVariants[0].compare_at_price / 100);
              } else {
                priceMin = parseFloat(sortedVariants[0].price);
                compareAtPriceMin = parseFloat(sortedVariants[0].compare_at_price);
              }
              if (parseFloat(sortedVariants[0].price) != parseFloat(sortedVariants[sortedVariants.length - 1].price)) {
                fromText = 'De la ';
              }
          }
      
		// Check on sale
		var onSale = compareAtPriceMin > priceMin;
		// Format price
		var price = Utils.formatMoney(priceMin);
		var compareAtPrice = '';
		if (this.data && compareAtPriceMin) {
			compareAtPrice = Utils.formatMoney(compareAtPriceMin);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, fromText + price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
    }
  // End Boost 175845  
 Utils.buildProductItemUrl = function(data, hasCollection) {
      //console.log('buildProductItemUrl');
      // Get url information
      var params = Utils.getWindowLocation().search.substring(1);
      var pathname = window.location.pathname;
      var elements = pathname.split('/');
    
      // Check if has locale
      var localeURLPart = "";
      var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
      if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
      } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
      }
    
      // Get product handle
      var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
      var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
      if (hasCollection) {
        // Homepage or Search page
        if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
          var preHandle = localeURLPart + '/collections/all/products/';
          return preHandle + handle;
    
          // Tag Page
        } else if (Utils.isTagPage()) {
          var preHandle = localeURLPart + '/collections/';
          var collectionHandleIndex = elements.indexOf("collections") + 1
          if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          return '/collections/all/products/' + handle;
        } else {
          // Google cache URL
          // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
          if (params.indexOf('cache:') > -1) {
            var collectionHandle = 'all';
            var temp = params.split('&')[0].split('?')[0].split('collections/');
            if (temp.length > 1) {
              if (temp[1].indexOf('/') > -1) {
                collectionHandle = temp[1].split('/')[0];
              } else {
                collectionHandle = temp[1];
              }
            }
            collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
            return '/collections/' + collectionHandle + '/products/' + handle;
          }
          var collectionHandleIndex = elements.indexOf("collections") + 1;
          var preHandle = localeURLPart + '/collections/';
          
          if (typeof elements[2] !== 'undefined') {
            // Build for collection pages
            if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
              return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
            }
            //Build for other pages, use collection/all
            return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
          } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
            return '/products/' + handle;
          }
          return window.location.pathname + '/products/' + handle;
        }
      }
      return localeURLPart + '/products/' + handle;
    }; 
})();